<div style="margin: auto; position: fixed; left: 25%; top: 45%; right: 25%">
  <!--
  <div class="ppImage">
    <img src="../../assets/images/powerPortal_Qualus.png" style="width: 80%; margin-left: 10%">
  </div>
  -->
  <div style="margin: auto; width: 50px; height: 50px;">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
  <label class="textClass">Syncing Portal...</label>
</div>
